module.exports = __webpack_public_path__ + "8f2dbecbe4c05e241bb1eb40cced52a7.pdf";